export enum ChangeRequestStatusType {
	Created = "Created",
	Accepted = "Accepted",
	Declined = "Declined"
}
